import { render, staticRenderFns } from "./university-charter.vue?vue&type=template&id=0160834b"
import script from "./university-charter.vue?vue&type=script&lang=js"
export * from "./university-charter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports